import { ParentModel } from '@blueprint/frontend-basics'
import { IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator'

export class ShopDto extends ParentModel {
  @IsUUID()
  @IsOptional()
  id?: string

  @IsString()
  @IsNotEmpty()
  name?: string

  @IsOptional()
  creationDate?: string

  constructor() {
    super()
  }
}
